import { expected } from '@aloft/toolkit-shared';

import { useEffect } from 'react';

import { resolveFeatureGridFieldConflicts } from '../../../../redux/features/actions/resolveFeatureGridFieldConflicts.ts';
import { selectFeatureGridConflictedFields } from '../../../../redux/features/selectors/uiSelectors.ts';
import { addFeatureGridConflictedField } from '../../../../redux/features/uiSlice.ts';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks.ts';
import { PropertyGridFieldName } from '../../types.ts';

type UseFieldConflictDetectionParams = {
  propertyDataFieldName: string;
  fieldName: PropertyGridFieldName;
  propertyId: string;
  fieldHasConflict: boolean;
  conflictIsResolved?: boolean;
  options: { value?: string }[];
};

export const useFieldConflictDetection = ({
  propertyDataFieldName,
  fieldName,
  propertyId,
  fieldHasConflict,
  conflictIsResolved,
  options,
}: UseFieldConflictDetectionParams) => {
  const dispatch = useAppDispatch();
  const conflictedFields = useAppSelector(selectFeatureGridConflictedFields);

  useEffect(() => {
    if (fieldHasConflict && conflictIsResolved) {
      const conflictedField = conflictedFields[propertyDataFieldName];
      if (conflictedField) {
        dispatch(
          resolveFeatureGridFieldConflicts({
            [propertyDataFieldName]: conflictedField,
          }),
        );
      }
    }

    if (options.length === 0 || conflictIsResolved || fieldHasConflict) return;

    const allOptionsMatch = options.every((option) => option.value === expected(options[0]).value);
    if (!allOptionsMatch) {
      dispatch(
        addFeatureGridConflictedField({ [propertyDataFieldName]: { fieldName, propertyId } }),
      );
    }
  }, [fieldHasConflict, conflictIsResolved, options]);
};
